import { jsx as _jsx } from "react/jsx-runtime";
import { OperativeTemplate } from '../../../../components/common/Templates/OperativeTemplate';
import { PDDForm } from './PDDForm';
export const PDDFormPage = () => {
    return (_jsx(OperativeTemplate, Object.assign({ title: "PDDForm.title" }, { children: _jsx(PDDForm, {}) })));
};
